import React from 'react';
import { Typography } from '@material-ui/core';
import { Column } from 'devextreme-react/data-grid';
import { withStyles } from '@material-ui/core/styles';
import DataGrid from 'components/devExtreme/DataGrid';

const AuctionUWBuyBoxCriterias = ({ selectedAuctionICBMStrategies, classes }) => {
  return (
    <div style={{ height: 'calc(100% - 17px)' }}>
      {(!selectedAuctionICBMStrategies || selectedAuctionICBMStrategies.length === 0)
        ? <Typography variant="subtitle1" color='textSecondary' className={classes.noICBMOrderText}>No ICBM Orders Available.</Typography>
        : <DataGrid
          dataSource={selectedAuctionICBMStrategies}
          keyExpr='id'
          allowColumnReordering={true}
          allowColumnResizing={true}
          columnResizingMode='widget'
          showRowLines={true}
          showColumnLines={true}
          // width={700}
          width={'100%'}
          height={'100%'}
          paging={{ enabled: false }}
        >
          <Column dataField='strategyName' caption='Strategy' width={100} alignment='right' />
          <Column dataField='capRateRentalMin' caption='Min Cap Rate' width={68} dataType='number' format={{ type: 'percent', precision: 2 }} alignment='right' />
          <Column dataField='netMarginFloor' caption='Net Margin Floor' width={68} dataType='number' format={{ type: 'percent', precision: 2 }} alignment='right' />
          {/* <Column dataField='capRateRentalMinOverride' caption='Min Cap Rate Override' alignment='right' /> */}
          <Column dataField='bedsMin' caption='Min Beds' width={50} dataType='number' alignment='right' format={{ type: 'fixedPoint', precision: 0 }} />
          <Column dataField='bathsMin' caption='Min Baths' width={54} dataType='number' alignment='right' format={{ type: 'fixedPoint', precision: 1 }} />
          <Column dataField='vintageMin' caption='Min Vintage' width={63} dataType='number' alignment='right' />
          <Column dataField='schoolScoreMin' caption='Min School Score' width={70} dataType='number' alignment='right' format={{ type: 'fixedPoint', precision: 1 }} />
          <Column dataField='rentMin' caption='Min Rent' width={64} dataType='number' format={{ type: 'currency', precision: 0 }} alignment='right' />
          <Column dataField='sqFeetMin' caption='Min Sqft' width={53} dataType='number' alignment='right' format={{ type: 'fixedPoint', precision: 0 }} />
          <Column dataField='medianIncomeMin' caption='Min Med Income' width={70} dataType='number' format={{ type: 'currency', precision: 0 }} alignment='right' />
          <Column dataField='fetchedDate' caption='Fetched Date' width={60} dataType='datetime' alignment='right' />
        </DataGrid>
      }
    </div>
  )
};

const styles = theme => ({
  noICBMOrderText: {
    color: 'E6E8E6'
  }
});
export default withStyles(styles)(AuctionUWBuyBoxCriterias);
